/** @jsx jsx */

import { jsx, css } from '@emotion/core';
import { Link } from '@zapier/common-components';
import { Colors } from '@zapier/theme';

const Styles = {
  container: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 1em;
    padding: 12px 0;
    border-bottom: 1px solid ${Colors.adamantium};
  `,
  name: css`
    color: ${Colors.black};
    font-weight: 600;
    line-height: 18px;
  `,
};

type Props = {
  name: string;
  href?: string;
  linkText: string;
};

export const ExplanationFeatureLine = (props: Props) => {
  const { name, href, linkText } = props;

  return (
    <div css={Styles.container}>
      <div css={Styles.name}>{name}</div>

      <Link color={Colors.steel} href={href} target="_blank" underline="always">
        {linkText}
      </Link>
    </div>
  );
};
